<template>
    <div class="assetAppraiser">
        <div class="condition">
            <div class="item">
                <div class="label">查询:</div>
                <div class="input">
                    <el-input v-model="conditionData.Word" size="small" placeholder="请输入报案号/车牌/被保险人/物主/物损名称"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">机构:</div>
                <div class="input">
                    <el-select v-model="conditionData.MechanismId" placeholder="请选择" size="small" @change="changeMechanismName">
                        <el-option
                        v-for="item in mechanismList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="conditionData.Mechanism" size="small" placeholder="请输入"></el-input> -->
                </div>
            </div>
            <div class="item">
                <div class="label">作业人员:</div>
                <div class="input">
                    <el-input v-model="conditionData.Operator" size="small" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">案件类型:</div>
                <div class="input">
                    <!-- <el-cascader
                    v-model="assetsType"
                    :options="assetsTypeList"
                    size="small"
                    @change="handleAssetsTypeChange"></el-cascader> -->

                    <el-select v-model="conditionData.AssetsTypes" placeholder="请选择" size="small" multiple>
                        <el-option
                        v-for="item in assetsTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">事故地:</div>
                <div class="input">
                    <el-cascader
                    size="small"
                    :options="options"
                    v-model="selectedOptions"
                    @change="handleRegionChange">
                    </el-cascader>
                </div>
            </div>
            <div class="item">
                <div class="label">审核状态:</div>
                <div class="input" style="width:400px">
                    <el-select v-model="conditionData.AuditStates" placeholder="请选择" size="small" multiple  style="width:400px">
                        <el-option
                        v-for="item in auditStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">委托时间:</div>
                <el-date-picker
                v-model="conditionData.startTime"
                size="small"
                type="date"
                format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.endTime"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div> 
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">搜索</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <!-- <el-tabs v-model="activeName" type="card" size="small" @tab-click="handleClick">
                    <el-tab-pane label="作业待审核" name="作业待审核"></el-tab-pane>
                    <el-tab-pane label="作业审核退回" name="作业审核退回"></el-tab-pane>
                    <el-tab-pane label="作业审核通过" name="作业审核通过"></el-tab-pane>
                    <el-tab-pane label="用印待审核" name="用印待审核"></el-tab-pane>
                    <el-tab-pane label="用印审核不通过" name="用印审核不通过"></el-tab-pane>
                    <el-tab-pane label="用印审核通过" name="用印审核通过"></el-tab-pane>
                </el-tabs> -->
                <el-button type="primary" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                prop="assetsTypeStr"
                label="案件类型"
                align="center"
                width="80px"
                >
                </el-table-column>
                <el-table-column
                prop="clientName"
                label="委托人"
                align="center"
                width="150px"
                >
                </el-table-column>
                <el-table-column
                prop="inCaseNo"
                label="报案号"
                align="center"
                width="140px"
                >
                </el-table-column>
                <el-table-column
                prop="caseName"
                label="案件名称"
                align="center"
                width="200px"
                >
                </el-table-column>
                <el-table-column
                prop="caseNo"
                label="报告编号"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="mechanism"
                label="作业机构"
                align="center"
                width="100px"
                >
                </el-table-column>
                <el-table-column
                prop="operator"
                label="作业人员"
                align="center"
                width="90px"
                >
                </el-table-column>
                
                
                <el-table-column
                prop="damageTime"
                label="事故日期"
                align="center"
                width="100px"
                >
                </el-table-column>
                <el-table-column
                prop="entrustDate"
                label="委托日期"
                align="center"
                width="100px"
                >
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="录入日期"
                align="center"
                width="100px"
                >
                </el-table-column>

                <el-table-column
                prop="assetsStateStr"
                label="案件状态"
                align="center"
                width="110px"
                >
                </el-table-column>
                <el-table-column
                prop="financialState"
                label="财务状态"
                align="center"
                width="110px"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.financialState==10?'已开票未回款':''}}</span>
                    <span>{{scope.row.financialState==15?'已开票部分回款':''}}</span>
                    <span>{{scope.row.financialState==20?'回款完成':''}}</span>
                    <span>{{scope.row.financialState==25?'已收款未开票':''}}</span>
                    <span>{{scope.row.financialState==0?'其他':''}}</span>
                </template>
                </el-table-column>
                
                
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-document" size="mini" @click="detail(scope.row,0)">详情</el-button>
                    <!-- <el-button type="text" icon="el-icon-document" size="mini" @click="auditDetail(scope.row)">审核</el-button> -->
                    <el-button type="text" icon="el-icon-document" size="mini" @click="audit(scope.row,10)" v-if="scope.row.auditState == 10">作业审核</el-button>
                    <el-button type="text" icon="el-icon-document" size="mini" @click="audit(scope.row,30)" v-if="scope.row.auditState == 30&&isHQ">总部审核</el-button>
                    <el-button type="text" icon="el-icon-document" size="mini" @click="audit(scope.row,70)" v-if="scope.row.auditState == 70&&isHQ">归档审核</el-button>
                    <!-- <el-button type="text" icon="el-icon-document" size="mini" @click="report(scope.row)">预览报告</el-button> -->
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :visible.sync="isNoAudit" title="审核不通过" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="textarea">
                        <el-input v-model="remark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="noAudit">确认提交</el-button>
                </div>
            </div>
        </el-dialog>


        
       
    </div>
</template>
<script>
import api from '../../../api/main'
import {assetsTypeList,assetsStateList,auditStateList,auditStateListC} from '../../../assets/selectList/assetsSelectList'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
export default {
    name: 'assetAppraiser',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            activeName:'作业待审核',
            selectedOptions:[],
            area:[],
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            AssetsTypes:[],
            conditionData:localStorage.getItem('conditionData')?JSON.parse(localStorage.getItem('conditionData')):{
                Word:'',
                MechanismId:'',
                Operator:'',
                AssetsCaseType:2,
                AssetsTypes:[],
                AuditStates:[],
                IsZCPG:false,
                CrimeCity:'',
                page:1,
                pageSize:10,
            },

            tableData:[],
            options:provinceAndCityData,
            assetsType:[],
            assetsTypeList:[{
                value:6,
                label:'企财险'
            },
            {
                value:7,
                label:'家财险'
            },
            {
                value:8,
                label:'工程机械设备险'
            },
            {
                value:14,
                label:'建工险'
            },
            {
                value:15,
                label:'船舶险'
            },
            {
                value:9,
                label:'货运险'
            },
            {
                value:10,
                label:'农险'
            },
            {
                value:11,
                label:'风险咨询'
            },{
                value:12,
                label:'其他'
            }],
            auditStateList:auditStateList,
            assetsStateList:assetsStateList,
            isNoAudit:false,
            remark:'',
            id:'',
            roles:localStorage.getItem('roles'),
            isHQ:false,
            mechanismList:[],
            MechanismName:'',
        }
    },
    created(){
        

    },
    mounted(){
        if(this.roles=='管理员'||this.roles=="评估审核员"||this.roles=="财产险审核员"||this.roles=="调查审核员"){
            this.auditStateList = auditStateList;
            this.isHQ = true;
            this.conditionData.AuditStates = [10,30,70]
        }else{
            this.auditStateList = auditStateListC;
            this.isHQ = false;
            this.conditionData.AuditStates = [10]
        }
        this.loadingData();
        this.getMechanismList();
    },
    methods:{
        async getMechanismList(){
            let res  = await api.QueryMechanism({});
            this.mechanismList = res.data.data.data;
        },
        changeMechanismName(e){
            console.log(e);
            for(let index in this.mechanismList){
                if(this.mechanismList[index].id==e){
                    this.MechanismName = this.mechanismList[index].name;
                    return;
                }
            }
        },
        handleClick(e){
            if(e.label=='作业待审核'){
                this.conditionData.AuditState = 10;
            }else if(e.label=='作业审核退回'){
                this.conditionData.AuditState = 15;
            }else if(e.label=='作业审核通过'){
                this.conditionData.AuditState = 30;
            }else if(e.label=='用印待审核'){
                this.conditionData.AuditState = 35;
            }else if(e.label=='用印审核不通过'){
                this.conditionData.AuditState = 40;
            }else if(e.label=='用印审核通过'){
                this.conditionData.AuditState = 50;
            }
            this.loadingData();
        },
        async report(row){
            console.log(row);
            if(row.assetsType == 1){
                this.$router.push({
                    name:'materialReport',
                    query:{
                        id:row.id,
                        isNoCreateReport:true,
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carReport',
                    query:{
                        id:row.id,
                        isNoCreateReport:true,
                    }
                });
            }
            // else if(row.assetsType == 3){
            //     this.$router.push({
            //         name:'commonCarReport',
            //         query:{
            //             id:row.id,
            //             isNoCreateReport:true,
            //         }
            //     });
            // }
            else if(row.assetsType == 5){
                this.$message({
                    type: 'success',
                    message: '正在下载，请稍等!'
                })
                let r = await api.queryAssetsCarInsuranceResponse(row.id);
                let detail = r.data.data
                // return;
                let imgList = [];

                for(let index in detail.assetsNalMap){
                    let isAddTitle = true;
                    for(let tindex in imgList){
                        if(imgList[tindex].Write == detail.assetsNalMap[index].assetsNulMapName){
                            isAddTitle = false;
                        }
                    }
                    if(imgList.length == 0){
                        imgList.push({
                            MoveToBookmark:'',
                            Write:detail.assetsNalMap[index].assetsNulMapName,
                            ImgBytes:[]
                        })
                    }else if(isAddTitle){
                        imgList.push({
                            MoveToBookmark:'',
                            Write:detail.assetsNalMap[index].assetsNulMapName,
                            ImgBytes:[]
                        })
                    }
                }
                for(let index in detail.assetsNalMap){
                    for(let tindex in imgList){
                        if(imgList[tindex].Write == detail.assetsNalMap[index].assetsNulMapName){
                            imgList[tindex].ImgBytes.push(detail.assetsNalMap[index].path)
                        }
                    }
                };
                //放弃索赔声明
                for(let index in imgList){
                    if(imgList[index].Write.indexOf('放弃索赔') != -1){
                        imgList[index].MoveToBookmark = 'Disclaimer'
                        imgList.push(imgList[index]);
                        imgList.splice(index,1);
                    }
                    
                }
                
                // return;
                let option = {
                    "HomePageTime": this.CNDateString(detail.assets.entrustDate),
                    "CompanyName": detail.assets.clientName,
                    "EntrustTime": detail.assets.entrustDate,
                    "PlaceOfDanger": detail.carInsurance.dangerAddress,
                    "CarBrand": detail.carInsurance.license,
                    "ThisCase": detail.assets.caseName,
                    "CaseInfo": detail.carInsurance.wtfh,
                    "EndPageTime": this.nowDate(),
                    "AccidentNO": detail.carInsurance.sgNumber,
                    "TimeOfDanger": detail.assets.damageTime,
                    "After": detail.carInsurance.dangerJg,
                    "Driver": detail.carInsurance.jsy,
                    "DispatchTime": detail.carInsurance.pgTime,
                    "PolicyNo": detail.carInsurance.policyNumber,
                    "TheInsured": detail.carInsurance.bbxr,
                    "BrandModel": detail.carInsurance.brand,
                    "FrameNo": detail.carInsurance.vehicleNo,
                    "PolicyDuration": this.nowDate(detail.carInsurance.bxdStartTime)+'——'+this.nowDate(detail.carInsurance.bxdEndTime),
                    "Safe": detail.carInsurance.bxje,
                    "Doubt": detail.carInsurance.wtsxjzayd,
                    "ExamineGoBy": '\n\n'+detail.carInsurance.dcjg,
                    "InsuranceLiability": detail.carInsurance.bxzr,
                    "InvestigationConclusion": '\n\n'+detail.carInsurance.dcjl,
                    "SubmitTime": this.nowDate(),
                    "Investigator": "",
                    "DataInfo": imgList
                }
                console.log(JSON.stringify(option));
                let res = await api.queryReport(option,detail.assets.caseName+'报告');
                console.log(res);
            }else{
                this.$message({
                    type: 'success',
                    message: '正在下载，请稍等!'
                })
                let res = await api.downLoadAsset({id:row.id},row.caseName+'报告');
            }
            
        },
        nowDate(d){
            let date
            if(d){
                date = new Date(d);
            }else{
                date = new Date();
            }
            let year = date.getFullYear();
            let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
            let day = date.getDate()>9?date.getDate():'0'+(date.getDate());
            return year+'年'+month+'月'+day+'日'
        },
        CNDateString(date){
            date = new Date(date)
            var cn = ["〇","一","二","三","四","五","六","七","八","九"];
            var s = [];
            var YY = date.getFullYear().toString();
            for (var i=0; i<YY.length; i++)
            if (cn[YY.charAt(i)])
            s.push(cn[YY.charAt(i)]);
            else
            s.push(YY.charAt(i));
            s.push("年");
            var MM = date.getMonth()+1;
            if (MM<10)
            s.push(cn[MM]);
            else if (MM<20)
            s.push("十" + cn[MM% 10]);
            s.push("月");
            var DD = date.getDate();
            if (DD<10)
            s.push(cn[DD]);
            else if (DD<20)
            s.push("十" + cn[DD% 10]);
            else if (DD<30)
            s.push("二十" + cn[DD% 10]);
            else
            s.push("三十" + cn[DD% 10]);
            s.push("日");
            return s.join('');
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        handleAssetsTypeChange(){
            console.log(this.assetsType);
            this.conditionData.AssetsType = this.assetsType[1];
        },
        handleRegionChange(codeArray){
            console.log(codeArray);
            if(codeArray[0]){
                this.conditionData.Province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.conditionData.CrimeCity = CodeToText[codeArray[1]]
            }
            // if(codeArray[2]){
            //     this.conditionData.Area = CodeToText[codeArray[2]]
            // }
        },
        getDateYMD(date){
            let d = new Date(date);
            let year = d.getFullYear() > 9 ? d.getFullYear() : '0' + d.getFullYear();
            let month = (d.getMonth()+1) > 9 ? d.getMonth()+1 : '0' + (d.getMonth()+1);
            let day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
            return year + '-' + month + '-' + day
        },
        getDate(date){
            let d = new Date(date);
            let year = d.getFullYear() > 9 ? d.getFullYear() : '0' + d.getFullYear();
            let month = (d.getMonth()+1) > 9 ? d.getMonth()+1 : '0' + (d.getMonth()+1);
            let day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
            let h = d.getHours() > 9 ? d.getHours() : '0' + d.getHours();
            let m = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes();
            let s = d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds();
            return year + '-' + month + '-' + day + ' ' + h + ':' + m + ':' + s
        },
        async loadingData() {
            let option = {
                Word:this.conditionData.Word,
                AssetsTypes:JSON.stringify(this.conditionData.AssetsTypes),
                // AssetsType:this.conditionData.AssetsType,
                MechanismId:this.conditionData.MechanismId,
                Operator:this.conditionData.Operator,
                IsZCPG:this.conditionData.IsZCPG,
                AssetsCaseType:this.conditionData.AssetsCaseType,
                AuditStates:JSON.stringify(this.conditionData.AuditStates),
                CrimeCity:this.conditionData.CrimeCity,
                startTime:this.conditionData.startTime,
                endTime:this.conditionData.endTime,
                page:this.conditionData.page,
                pageSize:this.conditionData.pageSize,
                Mechanism:this.MechanismName
            }
            let res  = await api.queryAssetsType(option);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            for(let index in this.tableData){
                this.tableData[index].damageTime = this.getDateYMD(this.tableData[index].damageTime);
                this.tableData[index].entrustDate = this.getDateYMD(this.tableData[index].entrustDate);
            }
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.MechanismName = '';

            this.assetsType = [];
            this.conditionData = {
                AssetsCaseType:2,
                AssetsTypes:[],
                Word:'',
                Operator:'',
                MechanismId:'',
                AuditStates:[10],
                CrimeCity:'',
                IsZCPG:false,
                page:1,
                pageSize:10,
            };
            if(this.isHQ){
                this.conditionData.AuditStates = [10,30]
            }
            this.selectedOptions=[];
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        
        async isUpdateDialogShow(row){
            let res  = await api.QuryMechanismById({
                MechanismId:row.id
            });
            console.log(res);
            this.area = res.data.data.cityCode.split(',');
            this.isUpdateDialog = true;
            this.updateData = res.data.data;
        },
        detail(row,isEdit){
            localStorage.setItem('conditionData',JSON.stringify(this.conditionData))
            if(row.assetsType == 1){
                this.$router.push({
                    name:'materialDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                    }
                });
            }else if(row.assetsType == 3){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                    }
                });
            }else if(row.assetsType == 4){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                    }
                });
            }else if(row.assetsType == 5){
                this.$router.push({
                    name:'carInsuranceDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                    }
                });
            }else{
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                    }
                });
            }
            
        },
        
        // 取消
        cancel(row){
            this.id = row.id;
            this.$confirm('是否取消案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateAssetsState(0);
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已退回案件'
                // });   
            });
        },
        async updateAssetsState(state){
            console.log(state);
            console.log(this.id);
            let res = await api.UpdateAssetsState({
                "id": this.id,
                "assetsState": state,
                "remark": this.remark
            });
            this.loadingData();
        },
        auditDetail(row){
            this.$router.push({
                name:'auditCaseDetail',
                query:{
                    id:row.id,
                }
            });
        },
        audit(row,state){
            localStorage.setItem('conditionData',JSON.stringify(this.conditionData))
            // this.id = row.id;
            // this.$confirm('是否审核通过?', '提示', {
            //     confirmButtonText: '审核通过',
            //     cancelButtonText: '审核不通过',
            //     type: 'warning'
            // }).then(() => {
            //     this.updateAssetsAuditState(row.id,50);
            // }).catch((e) => {
            //     this.isNoAudit = true;
            // });
            if(row.assetsType == 1){
                this.$router.push({
                    name:'materialDamage',
                    query:{
                        id:row.id,
                        isAudit:true,
                        auditState:state,
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carDamage',
                    query:{
                        id:row.id,
                        isAudit:true,
                        auditState:state,
                    }
                });
            }
            // else if(row.assetsType == 3){
            //     this.$router.push({
            //         name:'commonCarDamage',
            //         query:{
            //             id:row.id,
            //             isAudit:true,
            //             auditState:10,
            //         }
            //     });
            // }
            else if(row.assetsType == 4){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isAudit:true,
                        auditState:state,
                    }
                });
            }
            else if(row.assetsType == 5){
                this.$router.push({
                    name:'carInsuranceDamage',
                    query:{
                        id:row.id,
                        isAudit:true,
                        auditState:state,
                    }
                });
            }else {
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isAudit:true,
                        auditState:state,
                    }
                });
            }
        },
        noAudit(){
            this.updateAssetsAuditState(this.id,45);
        },
        async updateAssetsAuditState(id,state){
            let res = await api.UpdateAssetsAuditState({
                "id": id,
                "auditState": state,
                "auditRemark": this.remark,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.remark = '';
                this.isNoAudit = false;
                this.loadingData();
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 5px;
            .label{
                min-width: 110px;
            }
            .input{
                width: 215px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 100px;
            }
            .value{
                width: 215px;
            }
            .textarea{
                width: 630px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
